import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import AccordionSection from '../AccordionSection';
import CopyButton from '../CopyButton';

/**
 * Judge feedback display component
 */
const JudgeFeedback = ({ evaluation, expanded, onToggle }) => {
  const copyText = useMemo(() => {
    const judgeFeedback = [
      evaluation?.issues && evaluation.issues.length > 0 
        ? `Issues Found:\n${evaluation.issues.map((issue, idx) => `${idx + 1}. ${issue}`).join('\n')}`
        : '',
      evaluation?.reasoning ? evaluation.reasoning : ''
    ].filter(Boolean).join('\n\n');
    
    return `=== JUDGE FEEDBACK ===\n\n${judgeFeedback || 'No judge feedback available'}`;
  }, [evaluation]);

  return (
    <div className="relative">
      <AccordionSection
        title="Judge Feedback"
        defaultExpanded={true}
        colorTheme="gray"
        expanded={expanded}
        onToggle={onToggle}
      >
        <div className="space-y-4">
          {evaluation?.issues && evaluation.issues.length > 0 && (
            <div>
              <p className="text-xs font-medium text-red-300 mb-2">
                Issues Found ({evaluation.issues.length})
              </p>
              <ul className="space-y-2">
                {evaluation.issues.map((issue, idx) => (
                  <li key={idx} className="bg-red-900/20 border border-red-500/40 rounded-lg p-3 text-sm text-red-200">
                    {issue}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {evaluation?.reasoning && (
            <div>
              <p className="text-xs font-medium text-gray-300 mb-2">Evaluation Reasoning</p>
              <div className="bg-gray-900/50 rounded-lg p-3 text-sm text-gray-200 whitespace-pre-wrap">
                {evaluation.reasoning}
              </div>
            </div>
          )}
        </div>
      </AccordionSection>
      <CopyButton
        onCopy={copyText}
        ariaLabel="Copy judge feedback"
        title="Copy judge feedback"
        colorTheme="gray"
      />
    </div>
  );
};

JudgeFeedback.propTypes = {
  evaluation: PropTypes.object,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default React.memo(JudgeFeedback);

